import ga4 from '../lib/ga-helper'

$(function() {
    console.log('LOADED WVM Gadget.')
    window.dataLayer.push({
      event: 'calculator_use',
      calculator_name: 'Women VS Man calc',
      step_number: 1,
      step_name: "Step 1",
     });
    $('.js-gadget-wvm-compare').on('click', function(e) {
        e.preventDefault()
        ga4.trackEvnt('calculator_woman_and_super', {'conversion_type': 'compare'})
        $('.js-gadget-wvm-age').trigger('blur')
        showResult()
    });
    $('.js-gadget-wvm-age').on("keypress", function(e) {
        if (e.which == 13) {
            $(this).trigger('change')
            showResult();
        }
    })
    $('.js-gadget-wvm-age').on('change blur', function() {
        const age = $(this).val(),
            agemin = $(this).data('min'),
            agemax = $(this).data('max')
        if (age < agemin) {
            age = agemin;
            $(this).val(agemin);
        } else if (age > agemax) {
            age = agemax;
            $(this).val(agemax);
        }
    });
    function showResult() {
        var balances = [{
                age: 24,
                men: 8148,
                women: 7328
            },
            {
                age: 29,
                men: 25981,
                women: 23429
            },
            {
                age: 34,
                men: 56344,
                women: 46289
            },
            {
                age: 39,
                men: 95937,
                women: 75785
            },
            {
                age: 44,
                men: 139431,
                women: 107538
            },
            {
                age: 49,
                men: 190716,
                women: 142037
            },
            {
                age: 54,
                men: 246955,
                women: 182167
            },
            {
                age: 59,
                men: 316457,
                women: 236530
            },
            {
                age: 64,
                men: 402838,
                women: 318203
            },
            {
                age: 69,
                men:  453075,
                women: 403038
            },
            {
                age: 74,
                men:  509059,
                women: 451523
            },
            {
                age: 99,
                men: 507556,
                women: 436865
            }
        ];
        var age = Number($('.js-gadget-wvm-age').val().replace(/[^0-9]/g, ''));
        var balance = $.grep(balances, function(e) {
            return age <= e.age
        })[0];
        //for women
        var ratio = balance.women / balance.men * 100;
        var ratiolabel = ratio + '%';
        var diff = balance.men - balance.women;
        $('.js-gadget-wvm-agespan > span').html(age);
        $('.js-gadget-wvm-men-balance').html('$' + balance.men.formatMoney(0) + '<sup>*</sup>');
        $('.js-gadget-wvm-women-balance').html('$' + balance.women.formatMoney(0) + '<sup>*</sup>');
        $('.js-gadget-wvm-diff-balance').html('$' + diff.formatMoney(0));
        $('.js-gadget-wvm-women-mask').css({height: '1%'});
        $('.js-gadget-wvm-men-mask').css({height: '1%'});
        $('.js-gadget-wvm-step-one').addClass('hide');
        $('.js-gadget-wvm-step-two').removeClass('hide');
        window.setTimeout(function() {
            $('.js-gadget-wvm-women-mask').css({
                height: ratiolabel
            });
            $('.js-gadget-wvm-men-mask').css({
                height: '100%'
            });
            $('html,body').animate({
                scrollTop: ($('.gadget-women-v-men').offset().top - 100)
            }, 200, function() {
                //force the padding to be correct
                window.setTimeout(function() {
                    $('header').addClass('shrink');
                    // console.log('srhink');
                }, 200);
            });
        }, 500);
        window.dataLayer.push({
          event: 'calculator_complete',
          calculator_name: 'Women VS Man calc',
          step_number: 2,
          step_name: "Step 2",
         });
    }
    var section = "Inner page";
    if ($('.ga-wvm-gadget').hasClass('home')) {
        if ($('body').hasClass('member-landing')) section = "Member landing page";
        else section = "Employer landing page";
    }
    if ($('.ga-wvm-gadget').hasClass('tile')) {
        section = 'Inner page';
    }
    if ($('.ga-wvm-gadget').hasClass('tactical-tile')) {
        section = 'Sticky tile';
    }
    $('.ga-wvm-age').on('change', function() {
        const value = $(this).val()
        ga('send', 'event','Women and super gadget', section, 'Age field ' + value);
        let bracketed = "65+"
        if (value <= 24) {
            bracketed = "18-24";
        } else if (value >= 25 && value <= 34) {
            bracketed = "25-34";
        } else if (value >= 35 && value <= 44) {
            bracketed = "35-44";
        } else if (value >= 45 && value <= 54) {
            bracketed = "45-54";
        } else if (value >= 55 && value <= 64) {
            bracketed = "55-64";
        }
        ga4.trackEvnt('calculator_woman_and_super', {'user_age': bracketed})
     });
    $('.ga-wvm-compare').on('click', function() {
        ga('send', 'event','Women and super gadget', section, 'Compare');
    });
    $('.ga-wvm-cta').on('click', function(ev) {
        ev.preventDefault()
        ga4.trackEvnt('calculator_woman_and_super', {'conversion_type': 'start closing the gap'})
        ga('send', 'event','Women and super gadget', section, 'CTA - Start closing the gap')
        const scrollToElement = document.getElementById('js-wvm-cta-scroll-to'),
        pageHeader = document.querySelector('header .secondary-menu')
        if (scrollToElement && pageHeader) {
            const headerOffset = pageHeader.getBoundingClientRect().height,
            topOffset = (scrollToElement.getBoundingClientRect().top - (document.body.getBoundingClientRect().top)) + headerOffset
            window.scrollTo({ behavior: 'smooth', top: topOffset})
        } else  {
            window.location.href = '/member/super/grow-your-super/women-and-super'
        }
    })
    $('.ga-wvm-compare-again').on('click', function() {
        ga('send', 'event','Women and super gadget', section, 'Compare again');
    });
    $('.ga-wvm-pdf').on('click', function() {
        ga('send', 'event','Women and super gadget', section, 'ASFA PDF');
    });
    $('.js-gadget-wvm-compare-again').click(function(e) {
        $('.js-gadget-wvm-step-one').removeClass('hide');
        $('.js-gadget-wvm-step-two').addClass('hide');
        $('.js-gadget-wvm-age').focus();
        $('.js-gadget-wvm-age').val('');
        e.preventDefault();
    });
});

Number.prototype.formatMoney = function(c, d, t) {
    var n = this,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    c = isNaN(c = Math.abs(c)) ? 2 : c;
    d = d === undefined ? "." : d;
    t = t === undefined ? "," : t;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
